export const PAGE = {
  LAUNCHER: 'LAUNCHER',
  HOME: 'HOME',
  CONVO: 'CONVO',
  POPUP_NORMAL: 'POPUP_NORMAL',
  POPUP_CONNECTED: 'POPUP_CONNECTED',
  POPUP_NEW_MESSAGE: 'POPUP_NEW_MESSAGE',
  DIMMED_CONVO: 'DIMMED_CONVO',
};


export const MOMENT_TIME_LIMIT = 10000000000;

export const CALENDAR_STRINGS = {
  lastDay : '[Yesterday at] LT',
  sameDay : '[Today at] LT',
  sameElse : 'MMM DD, HH:mma'
};

export const GIF = {
  INPUT_PLACEHOLDER: "Search GIFs",
  LIMIT: 10,
  RATING: 'pg',
  TRENDING_ENDPOINT: 'trending',
  SEARCH_ENDPOINT: 'search',
  TOOLTIP: 'GIF',
};

export const GIF_UI_TEXT = {
  EMPTY: "Oh no! We couldn't find a single gif matching your search",
  REPLACE: 'Do you wanna replace the existing gif?',
};

export const MOMENT_STRINGS = {
  lastDay : '[Yesterday]',
  sameDay: '[Today]',
  lastWeek : 'dddd, DD MMM YYYY',
  nextWeek : 'dddd, DD MMM YYYY',
  sameElse : 'dddd, DD MMM YYYY'
}

export const ALLOWED_FILE_TYPES = [
  ".pdf",
  ".png",
  ".jpg",
  ".jpeg",
  ".gif",
  ".txt",
  ".mp4",
  ".mov",
  ".ppt",
  ".docx",
];

export const BREAKPOINTS = {
  MOBILE: 375,
};

export const CHAT_POPUP = {
  HEIGHT_MIN: 20,
  HEIGHT_MEDIUM: 40,
  HEIGHT_MAX: 60,
  WIDTH_MIN: 112,
  WIDTH_MAX: 240,
  INCREMENT_HEIGHT: 101,
  INCREMENT_WIDTH: 136,
  INCREMENT_HEIGHT_FORM_FACTOR: 50,
  INCREMENT_WIDTH_FORM_FACTOR: 40,
  STEP_INCREMENT: 4,
  ONE_LINE_WIDTH: 222,
};

export const WIDGET_ICON_OPTIONS = [
  {
    title: 'Option 1',
    url: 'https://insent-assets.s3.amazonaws.com/bot-logo/option-1.png',
  },
  {
    title: 'Option 2',
    url: 'https://insent-assets.s3.amazonaws.com/bot-logo/option-2.png',
  },
  {
    title: 'Option 3',
    url: 'https://insent-assets.s3.amazonaws.com/bot-logo/option-3.png',
  },
  {
    title: 'Option 4',
    url: 'https://insent-assets.s3.amazonaws.com/bot-logo/option-4.png',
  },
];